import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuLink } from '@common-modules/navigation/models/menu-link';
import { ModuleLink } from '@common-modules/navigation/models/module-link';

@Component({
    selector: 'wlm-module-link-expandable',
    templateUrl: './module-link-expandable.component.html',
    styleUrls: ['./module-link-expandable.component.scss'],
    standalone: false
})
export class ModuleLinkExpandableComponent implements OnInit {
  @Input() moduleLink: ModuleLink;
  panelOpenState = false;

  constructor(private _router: Router) {}

  ngOnInit(): void {}

  public navigate(menuLink: MenuLink) {
    this._router.navigateByUrl(menuLink.urlPath);
  }
}
